import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./InnerLayout.scss";

import "react-multi-carousel/lib/styles.css";

import { Link } from "gatsby";
import {
	MDBBadge,
	MDBNav,
	MDBNavItem,
	MDBView,
	MDBMask,
	MDBContainer,
	MDBRow,
	MDBCol,
	MDBBtn,
	MDBBtnGroup,
	MDBIcon,
} from "mdbreact";
import PropTypes from "prop-types";

import { GGgetMode } from "../../services/gglocalstorage";

import SEO from "../../components/SEO/Seo";
import ButtonCTA from "../../components/ButtonCTA/ButtonCTA";
import CardSkillset from "../../components/GG/CardSkillset/CardSkillset";

import { ConvertInstitutoToArea } from "../../helpers/Formatters";
import { ValidateHashPath } from "../../services/hashpathservice";
import CarouselCursos from "../../components/CarouselCursos/CarouselCursos";
import Layout from "../MasterLayout/MasterLayout";

/**
 * Layout para páginas internas, com ênfase nos cursos.
 * @param {object} children Itens que compõem a página.
 * @param {object} cursos Demais cursos associados que serão recomendados.
 * @returns Página
 */
export default function InnerLayout({ children, curso, listaGrupoCursos }) {
	InnerLayout.propTypes = {
		children: PropTypes.array.isRequired,
		curso: PropTypes.object.isRequired, // informação do curso
		listaGrupoCursos: PropTypes.array,
	};

	// Define a slug base da página
	let urlBase = `/cursos/${curso.Slug}`;

	let selectedIndex =
		typeof window !== "undefined"
			? ValidateHashPath(curso.Items.length, location.hash)
			: 0;
	let cursoSelecionado = curso.Items[selectedIndex];

	let instagramUrl = cursoSelecionado?.CanaisDoCurso?.Instagram?.Value;
	let facebookUrl = cursoSelecionado?.CanaisDoCurso?.Facebook?.Value;

	let hash = typeof window !== "undefined" ? location.hash : "#";

	return (
		<Layout color="#ffffff">
			<SEO title={curso.Title} />
			{/* <div
				className={
					GGgetMode() ? "innerHeader-wrapper-gg" : "innerHeader-wrapper"
				}
			>
				<MDBView>
					<MDBMask className="d-flex justify-content-center align-items-center" style={{ backgroundImage: 'linear-gradient(to right, #AECE41 -60%, #5ba82d 50%, #AECE41 160%)' }}>
						<MDBContainer>
							<MDBRow>
								<MDBCol
									md="12"
									className="white-text text-center text-md-left mt-xl-2 mb-2"
								>
									<h1 className="h1-responsive text-center font-weight-bold mt-sm-2">
										{curso.Title}
									</h1>
								</MDBCol>
							</MDBRow>
							<MDBRow>
								<MDBCol md="12" className="mt-4 text-center">
									<MDBBtnGroup size="lg">
									<MDBRow className="mt-4 text-center justify-content-center">
										{curso.Opcoes != null &&
											curso.Opcoes.map((o, index) => {
												// Caso o curso não esteja mais sendo ofertado ingresso.
												if (
													GGgetMode() &&
													curso.Items[index].Integracao.Ofertado.Value
												) {
													return null;
												} else {
													return (
														<Link to={`#${index}`}>
															<MDBBtn
																active={o == curso.Opcoes[selectedIndex]}
																color={GGgetMode() ? "gg" : "primary "}
																key={o}
															>
																 {o.includes("Híbrido") ? o.replace("Híbrido", "Presencial") : o}
															</MDBBtn>
														</Link>
													);
												}
											})}
											</MDBRow>
									</MDBBtnGroup>
								</MDBCol>
							</MDBRow>
							{cursoSelecionado.Integracao.Ofertado.Value && (
								<MDBRow>
									<MDBCol md="12" className="mt-2 text-center">
										<MDBBadge
											color="grey"
											className="rounded px-3 py-2 text-center font-weight-light"
										>
											Modalidade em extinção – sem oferta de ingresso.
											<br />
											Confira as outras modalidades disponíveis.
										</MDBBadge>
									</MDBCol>
								</MDBRow>
							)}
						</MDBContainer>
					</MDBMask>
				</MDBView>
			</div>
			<Container fluid>
				<Row>
					<Col style={{ paddingLeft: 0, paddingRight: 0 }}>
						<MDBNav
							style={{backgroundColor:"#fff"}}
							className={
								(GGgetMode() ? "pt-4 mb-4" : "py-4 mb-4") +
								" font-weight-bold px-2 justify-content-center"
							}
						>
							{curso.ItemsMenu.findIndex((o) => o == "Home") > -1 && (
								<MDBNavItem active={true}>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-primary btn"
												: "btn-primary btn"
										}
										to={`${urlBase}${hash}`}
									>
										Sobre o curso
									</Link>
								</MDBNavItem>
							)}
							{curso.ItemsMenu.findIndex((o) => o == "Disciplinas") > -1 && (
								<MDBNavItem>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-primary btn"
												: "btn-primary btn"
										}
										to={`${urlBase}/disciplinas${hash}`}
									>
										Estrutura Curricular
									</Link>
								</MDBNavItem>
							)}
							{curso.ItemsMenu.findIndex((o) => o == "CorpoDocente") > -1 && (
								<MDBNavItem>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-secondary btn-outline-secondary btn"
												: "btn-default btn-outline-secondary btn"
										}
										to={`${urlBase}/corpo-docente${hash}`}
									>
										{GGgetMode() ? "Professores" : "Corpo docente"}
									</Link>
								</MDBNavItem>
							)}
							{curso.ItemsMenu.findIndex((o) => o == "Ambientes") > -1 && (
								<MDBNavItem>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-secondary btn-outline-secondary btn"
												: "btn-default btn-outline-secondary btn"
										}
										to={`${urlBase}/infraestrutura${hash}`}
									>
										Infraestrutura
									</Link>
								</MDBNavItem>
							)}
							{curso.ItemsMenu.findIndex((o) => o == "Perfil") > -1 && (
								<MDBNavItem>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-secondary btn-outline-secondary btn"
												: "btn-default btn-outline-secondary btn"
										}
										to={`${urlBase}/perfil${hash}`}
									>
										Perfil
									</Link>
								</MDBNavItem>
							)}
							<MDBNavItem>
								{curso.ItemsMenu.findIndex((o) => o == "Investimento") > -1 && (
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-secondary btn-outline-secondary btn"
												: "btn-default btn-outline-secondary btn"
										}
										to={`${urlBase}/investimento${hash}`}
									>
										Investimento
									</Link>
								)}
							</MDBNavItem>
							{!GGgetMode() &&
							curso.ItemsMenu.findIndex((o) => o === "DiretorioAcademico") >
								-1 ? (
								<MDBNavItem>
									<Link
										className="btn-primary btn"
										activeClassName={
											GGgetMode()
												? "btn-secondary btn-outline-secondary btn"
												: "btn-default btn-outline-secondary btn"
										}
										to={`${urlBase}/diretorio-academico${hash}`}
									>
										Diretório Acadêmico
									</Link>
								</MDBNavItem>
							) : null} 
						</MDBNav>
					</Col>
				</Row>
			</Container>*/}
			{GGgetMode() && <hr className="bg-secondary p-0 m-0 mb-5" />}
			{children}
			<Container className="pt-5">
				{/* <Row className="py-3">
					<Col md="12">
						<Link to="/inscrevase">
							<ButtonCTA key="btnInscBottom" />
						</Link>
					</Col>
				</Row> */}

				{(instagramUrl || facebookUrl) && (
					<>
						<Row>
							<Col className="text-primary h5 my-auto text-center text-md-left">
								Siga o curso nas redes sociais:
							</Col>
						</Row>
						<Row className="my-3">
							<Col className="text-center">
								{instagramUrl && (
									<a
										href={instagramUrl}
										className={
											(GGgetMode() ? "text-primary" : "text-primary") +
											" text-decoration-none px-3"
										}
										target="_blank"
										rel="noreferrer"
									>
										<MDBIcon fab icon="instagram" size="4x" />
									</a>
								)}
								{facebookUrl && (
									<a
										href={facebookUrl}
										className={
											(GGgetMode() ? "text-primary" : "text-primary") +
											" text-decoration-none px-3"
										}
										target="_blank"
										rel="noreferrer"
									>
										<MDBIcon fab icon="facebook" size="4x" />
									</a>
								)}
							</Col>
						</Row>
					</>
				)}

				{listaGrupoCursos?.length > 0 && (
					<CarouselCursos
						cursos={listaGrupoCursos}
						instituto={ConvertInstitutoToArea(curso.Instituto)}
					/>
				)}
			</Container>
		</Layout>
	);
}
